export default __webpack_public_path__ + "static/media/carson-project-5.39cc975e.jpg";